// extracted by mini-css-extract-plugin
module.exports = {"listContainer":"HotelDetails_listContainer__Yw2ba","psaBanner":"HotelDetails_psaBanner__l1NQR","poolHours":"HotelDetails_poolHours__6pUMD"};